// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-option-group{border-bottom:1px solid var(--border-color);padding:8px 12px}.product-option-group-form-control{display:block}.product-option-group-label{padding-bottom:4px}.product-option-line{display:flex;align-items:center}.product-option-radio-checkbox{padding-top:4px;padding-bottom:4px}.product-option-price{margin-left:auto}\n", ""]);
// Exports
module.exports = exports;
